import React from 'react';
import env from '../../components/config/config';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node.isRequired,
};

const defaultProps = {};

const AuthStyle = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    .auth-wrapper {
        width: 450px;
    }

    .logo {
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .support-info {
        text-align: center;
        color: var(--biscay);
        font-size: 14px;
        font-weight: bold;
        margin: 0 auto;

        a,
        span {
            color: var(--easternBlue);
        }
    }

    .auth-box {
        a {
            color: var(--easternBlue);
        }

        background-color: var(--white);
        border-radius: 4px;
        padding: 20px;
        margin: 55px auto;
        box-shadow: 0 -1px 2px var(--shadow-color), 0 5px 15px rgb(50 50 93 / 10%), 0 5px 15px var(--shadow-color);
    }
`;

const AuthPage = ({ children }) => {
    return (
        <AuthStyle>
            <div className="auth-wrapper">
                <div className="logo">
                    <img
                        src={`${env.cdnURL}/images/stm/therigySTM-Logo-LightMode.png`}
                        alt="Therigy - The Trusted Source for Specialty Solutions"
                    />
                </div>
                <div className="auth-box">{children}</div>
                <p className="support-info">
                    For immediate assistance, contact Tech Support by phone at{' '}
                    <span id="support-phone-number">{env.supportPhoneNumber}</span> or via email at{' '}
                    <a id="support-email" href={`mailto:${env.supportEmail}`}>
                        {env.supportEmail}
                    </a>
                </p>
            </div>
        </AuthStyle>
    );
};

AuthPage.propTypes = propTypes;
AuthPage.defaultProps = defaultProps;

export default AuthPage;
